import React, { Component } from 'react';
import { Navbar, Nav, NavbarToggler, Collapse, NavItem, Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import { NavLink } from 'react-router-dom';

class Navigation extends Component{
    constructor(props){
        super(props);
        this.state = {
            isNavOpen: false,
            isDropdownOpen: false
        }
        this.toggleNav = this.toggleNav.bind(this);
        this.toggleDropdown = this.toggleDropdown.bind(this);
        this.handleDropdownClick = this.handleDropdownClick.bind(this);
        this.handleNavclick = this.handleNavclick.bind(this);
    }
    toggleNav(){
        this.setState({
            isNavOpen : !this.state.isNavOpen
        });
    }
    toggleDropdown(){
        this.setState({
            isDropdownOpen: !this.state.isDropdownOpen
        });
    }
    handleDropdownClick(){
        this.toggleDropdown();
        if(this.state.isNavOpen){
            this.toggleNav();
        }
    }
    handleNavclick(){
        if(this.state.isNavOpen){
            this.toggleNav();
        }
    }
    render(){
        return(
            <div>
                <Navbar dark expand="md" className="fixed-top">
                    <div className="container">
                        <NavbarToggler onClick={this.toggleNav}/>
                        <Collapse isOpen={this.state.isNavOpen} navbar>
                            <Nav navbar>
                                <NavItem>
                                    <NavLink className="nav-link" to="/home"><span className="fa fa-home fa-lg"></span> Home</NavLink>
                                </NavItem>
                                <Dropdown nav isOpen={this.state.isDropdownOpen} toggle={this.toggleDropdown}>
                                    <DropdownToggle nav caret><span className="fa fa-list fa-lg"></span> Visualizations</DropdownToggle>
                                    <DropdownMenu>
                                        <NavLink onClick={this.handleDropdownClick} className="dropdown-item" to="/stack">Stack</NavLink>
                                        <NavLink onClick={this.handleDropdownClick} className="dropdown-item" to="/queue">Queue</NavLink>
                                        <NavLink onClick={this.handleDropdownClick} className="dropdown-item" to="/bfs">BFS</NavLink>
                                        <NavLink onClick={this.handleDropdownClick} className="dropdown-item" to="/dfs">DFS</NavLink>
                                    </DropdownMenu>
                                </Dropdown>
                                <NavItem>
                                    <NavLink className="nav-link" to="/about"><span className="fa fa-user fa-lg"></span> About the Developers</NavLink>
                                </NavItem>
                            </Nav>
                        </Collapse>
                    </div>
                </Navbar>
            </div>
        );
    }
}

export default Navigation;